export const ENUM_DICT = {
  GET: {
    value: "GET",
    key: "audit.actions.read",
  },
  POST: {
    value: "POST",
    key: "audit.actions.create",
  },
  PUT: {
    value: "PUT",
    key: "audit.actions.update",
  },
  PATCH: {
    value: "PATCH",
    key: "audit.actions.update",
  },
  DELETE: {
    value: "DELETE",
    key: "audit.actions.delete",
  },
  CANCELED: {
    value: "CANCELED",
    key: "audit.actions.cancel",
  },
  GENERATED: {
    value: "GENERATED",
    key: "audit.actions.generate",
  },
  GENERATING: {
    value: "GENERATING",
    key: "audit.actions.create",
  },
  FAILURE: {
    value: "FAILURE",
    key: "audit.actions.generateFail",
  },
  LOGIN: {
    value: "LOGIN",
    key: "audit.actions.login",
  },
  EXPORTED_TO_ACOMBA: {
    value: "EXPORTED_TO_ACOMBA",
    key: "audit.actions.exportedToAcomba",
  },
};

export default Object.values(ENUM_DICT);

export const getAction = (key) => ENUM_DICT[key] || { key, value: key };



// WEBPACK FOOTER //
// ./src/components/dashboard/audit/enums/actionTypes.js